export default {
    changeOpenTableAddParameter(state, param) {
        state.openTableAddParameter=param.openTableAddParameter
    }
}